    <template >
  <div v-role="roles">

  <div>
  <div class="formPosition">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  <!--=========================DIALOGO DE DESBLOQUEIO DA PAUTA============================================-->      
  <template v-if="listEstudantfromPauta.length">

    <v-form ref="form" v-model="formValid" lazy-validation>
      <v-container class="text-md-left">
        <v-row no-gutters>
          <v-col>
            <v-card class="d-flex flex-row mb-6" tile>
              <v-list flat>
                 
                <v-header>
                   <div style="text-align:center">
                   Clique no botão + para adicionar a disciplina de <strong>FARMACOLOGIA</strong> na Pauta
                </div>   

                <div
                    v-if="$store.state.hasMessage"
                    :class="$store.state.classMessage"
                  >{{$store.state.textMessage}}</div>
   

                </v-header>
                <hr width="1200px" />

                <v-list-item-group v-model="item" color="primary">
                  <!--  1 e 2 trimestre  header -->
                  <v-row style="margin-left:50px">
                    <v-col cols="12" sm="12" md="1">N.</v-col>
                    <v-col cols="12" sm="12" md="4">Nome</v-col>

                     <v-col cols="12" sm="12" md="4">Turma</v-col>

                    <v-col cols="12" sm="12" md="2">Adicionar em Pauta</v-col>
                  </v-row>

                  <v-list-item v-for="(item, i) in listEstudantfromPauta" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <!-- body 1  trimestre -->

                 <v-row   >
                      <v-col cols="12" sm="12" md="1">{{i+1}}.</v-col>

                      <v-col cols="12" sm="12" md="4">
                        <v-list-item-title v-text="item.nome"></v-list-item-title>

                      </v-col>

                       <v-col cols="12" sm="12" md="4">
                        <v-list-item-title v-text="item.descricao"></v-list-item-title>

                      </v-col>
 
 
 

                      <v-col cols="12" sm="12" md="2">
                        <v-btn
                          color="primary"
                          fab
                          x-small
                          dark
                          @click="bt_save(item)"
                        >
                          <v-icon>add</v-icon>
                        </v-btn>

                      </v-col>
                    </v-row>
                  </v-list-item>

                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      </v-form >
    </template>
  </div>
  </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    formValid: true,
    on: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 20) || 'nota invalida',
      v => !isNaN(v) || 'not number ',

      v => (v.length <= 2) || 'valor inválido'

    ],
    text: '',
    resultado: [],
    editedpk: 0,
    overlay: false,
    profediscinas: [],
    role_usuario: '',
    disciplinas: [],
    _classe: '',
    Professor: '',
    dialog: false,
    dialogoDisabilita: false,
    progresso_2: false,
    progresso_3: false,
    lancamentoSelected: 1,
    progresso: true,
    idanoacademico: 0,
    offset: true,
    descricao_Prof: '',
    tumaSelect: '',
    iddisciplina: 0,
    btn_description: '',
    publicar_status: false,
    idturma: 0,
    closeOnClick: true,
    item: 1,
    listaPautasBloquadas: [],
    btn_activacao1: false,
    btn_activacao2: false,
    btn_activacao3: false,
    listaDeClassesPorLancarNotas: [],
    listEstudantfromPauta: [],
    roles: 'prof',
    items:
    [
      { id: 1, descricao: 'Nota por nota' },
      { id: 2, descricao: 'Todas as notas' }
    ],
    editedIndex: -1,
    editedItem: {
      pkpauta: 0,
      p1_notaMac: 0,
      p1_nota: 0,
      p1_nota2: 0,
      p1_MD: 0,
      p2_notaMac: 0,
      p2_nota: 0,
      p2_nota2: 0,
      p2_MD: 0,
      p3_notaMac: 0,
      p3_nota: 0,
      p3_MD: 0,
      pg: 0,
      ca: 0,
      mfd: 0
    }
  }),
  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    role () {
      return ls.get('role')
    }
  },

  watch: {

    listaDeClassesPorLancarNotas () {
      this.$store.state.isloading = false
    }
  },
  created () {
    
    this.CarregarAlunos()
  },

  methods: {
    classe (idanoacademico) {
      if (idanoacademico === 1) {
        this._classe = '10ª Classe'
      }
      if (idanoacademico === 2) {
        this._classe = '11ª Classe'
      }
      if (idanoacademico === 3) {
        this._classe = '12ª Classe'
      }
      if (idanoacademico === 4) {
        this._classe = '13ª Classe'
      }

      this.idanoacademico = idanoacademico
    },
    loadprogressbar () {
      this.$store.state.isloading = true
    },

    bt_edit (item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedpk = item.pkpauta
      this.editedItem.trimestre = this.$store.state.idperfilpauta
      this.editedItem.pkpauta = item.pkpauta

      setTimeout(() => {}, 1000)
    },
    MostrarDialogo () {
      this.dialog = true
    },

    MostrarDialogoDisabilitar () {
      this.dialogoDisabilita = true
    },
    bt_save (item) {
      this.VerificaExistenciaPauta(item.idMatricula, 390).then(()=>{
          if(this.resultado.length <=0 ){
               this.InserirRegistroEmPauta(item,390);
          }else{
              this.$store.dispatch('textMessage', {
              msg: 'Registro já existente em pauta',
              classMessage: 'msgError',
              timeout: 8000
            })
          }
      })
      
      setTimeout(() => {}, 1000)
    },
    backTodisciplinList () {
      this.listEstudantfromPauta = []
    },
    backToTurmaList () {
      this.disciplinas = []
    },

    async CarregarAlunos (){
       try {
        this.overlay = true
        this.listEstudantfromPauta = await axios

          .get('/ObterEstudantesFarmacia')
          .then(res => res.data)

        this.overlay = false
      } catch (error) {
        // this.isLoading = false
        this.overlay = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async InserirRegistroEmPauta (item, iddisciplina){
        var params = {
            item: item,
            iddisciplina: iddisciplina,
            descricao_disciplina:'Farmacologia',
            anoacademico: 2
        }

        try {
          let msg = await axios.post('/inserirDisciplinaPauta', params).then(res => res.data)
          //  this.close();

          if(msg.affectedRows >= 1){
             
            this.$store.dispatch('textMessage', {
              msg: 'Inserção efectuada com sucesso',
              classMessage: 'msgSucess',
              timeout: 8000
            })
          }else{
          this.$store.dispatch('textMessage', {
              msg: 'Erro ao tentar efectuar a operação',
              classMessage: 'msgError',
              timeout: 8000
            })
          }


        } catch (error) {
          this.isLoading = false

          this.text = error.message
          this.$store.dispatch('textMessage', {
            msg: this.text + ' - ' + error,
            classMessage: 'msgError',
            timeout: 8000
          })
        } finally {
        }
      },


    async VerificaExistenciaPauta (idmatricula,iddisciplina){
       try {
        this.overlay = true
        this.resultado = await axios

          .get('/verificaExistenciaPauta/'+idmatricula + '/'+iddisciplina )
          .then(res => res.data)

        this.overlay = false
      } catch (error) {
        // this.isLoading = false
        this.overlay = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async turmaFindWithEstudanteCount (idclasse) {
      this.progresso = true
      try {
        this.progresso = true
        this.listaDeClassesPorLancarNotas = await axios
          .get('/turmaFindWithEstudanteCount/' + 'all') // idclasse JyUn JQ==
          .then(res => res.data)
        console.log(this.listaDeClassesPorLancarNotas[0])
        this.progresso = false
      } catch (error) {
        // this.isLoading = false
        this.progresso = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      this.listEstudantfromPauta = []
    },
    async save (editedItem) {
      var params = {
        p1_notaMac: editedItem.p1_notaMac,
        p1_nota: editedItem.p1_nota,
        p1_nota2: editedItem.p1_nota2,
        p1_MD: editedItem.p1_MD,
        p2_notaMac: editedItem.p2_notaMac,
        p2_nota: editedItem.p2_nota,
        p2_nota2: editedItem.p2_nota2,
        p2_MD: editedItem.p2_MD,
        p3_notaMac: editedItem.p3_notaMac,
        p3_nota: editedItem.p3_nota,
        p3_MD: editedItem.p3_MD,
        pg: editedItem.pg,
        ca: editedItem.ca,
        mfd: editedItem.mfd,
        autor: editedItem.autor,
        pkpauta: editedItem.pkpauta,
        trimestre: editedItem.trimestre
      }

      try {
        let msg = await axios.post('/lancarNota', params).then(res => res.data)
        // this.text = msg[1].insertId
        this.text = msg

        try {
          if (msg.affectedRows >= 1) {
            this.text = msg.affectedRows + ' gravado(s) com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
          }
        } catch (error) {

        }
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } catch (error) {}
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } catch (error) {}

        if (this.editedIndex > -1) {
          //  Object.assign(this.estudantes[this.editedIndex], this.editedItem)
        } else {
          this.estudantes.push(this.editedItem)
        }
        //  this.close();
      } catch (error) {
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text + ' - ' + error,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
      }
    },

    async pautaByTurma (obj) {
      // carrega turma apartir de bauta  Turma
      this.$store.state.disciplina = obj
      const payload =
        '{"iddisciplina":"' +
        obj.iddisciplina +
        '" , "pkturma":"' +
        obj.pkturma +
        '", "i_id":"' +
        ls.get('i_id') +
        '"  }'

      try {
        this.progresso_3 = true
        this.listEstudantfromPauta = await axios

          .get('/listEstudantfromPauta/' + payload)
          .then(res => res.data)
        this.CarregaPautas()

        this.progresso_3 = false
        this.MostraProfessor()
      } catch (error) {
        // this.isLoading = false
        this.progresso_3 = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async initprofdisc (search) {
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }
        this.profediscinas = await axios
          .get('/professordiscFindAll/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async PublicarPauta () {
      const valores =
          {
            turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
            disciplina: this.$store.state.disciplina,
            trimestre: this.$store.state.lancarNotaDe,
            bloquear: 1,
            publicar: 1,
            idControlopauta: 0
          }

      // Consumindo a API
      try {
        // eslint-disable-next-line no-unused-vars
        let valor = await axios

          .post('/bloquearPauta', valores)
          .then(res => res.data)
        // eslint-disable-next-line no-unused-vars
        let text = 'Pauta publicada com sucesso'
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
        this.dialog = false

        this.$store.state.bloqueado.push(valores)
        // this.$store.state.bloqueado = []
        // CarregaPauta
        this.CarregaPautas()
        this.verificaPautas()
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
      } catch (error) {

      }
    },

    async DesbloquearPauta () {
      // Verificando se o Id esta disponivel
      /* if (this.$store.state.Controlopauta != null) {
        // CONSUMINDO A API ----  Passando a Id
        const valores =
            {
              turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
              disciplina: this.$store.state.disciplina,
              trimestre: 1,
              bloquear: 0,
              publicar: 0,
              idControlopauta: this.$store.state.Controlopauta
            }

        try {
          // eslint-disable-next-line no-unused-vars
          let valor = await axios

            .post('/bloquearPauta', valores)
            .then(res => res.data)
          // eslint-disable-next-line no-unused-vars
          let text = 'Pauta Bloqueada com sucesso'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
          this.dialog = false

          this.$store.state.bloqueado = []
          // CarregaPauta
          this.CarregaPautas()
          this.verificaPautas()

          this.dialogoDisabilita = false
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      } */
    },

    MostraProfessor () {
      let valor = this.profediscinas.filter(d => d.iddisciplina === this.$store.state.disciplina)
      if (valor.length) {
        this.Professor = valor[0].nome
        this.descricao_Prof = 'disciplina atrbuida ao Professor'
      } else {
        this.Professor = 'Sem Professor Associado'
        this.descricao_Prof = ''
      }
    },

    irParaValiacao (item) {
      this.$store.state.objPauta = item
      this.$store.state.rotas = 'lancar-trimestre-um'
      this.$router.push('avalicacao-comportamento')
    },

    async CarregaPautas () {
      try {
        let params =
        {
          iddisciplina: this.$store.state.disciplina,
          turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
          trimestre: '1º Trimestre'
        }

        this.$store.state.bloqueado = await axios

          .post('/ListarPautaBloqueada', params)
          .then(res => res.data)
        if (this.$store.state.bloqueado.length) { this.verificaPautas() }
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    HabilitaBotoes (valor) {
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '1º Trimestre')) {
        this.btn_activacao1 = valor
      }
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '2º Trimestre')) {
        this.btn_activacao2 = valor
      }
      if (this.listaPautasBloquadas.filter(t => t.trimestre === '3º Trimestre')) {
        this.btn_activacao3 = valor
      }
    },

    MudarFormaLancamento () {

    },

    verificaPautas () {
      if (this.listaPautasBloquadas.length) {
        this.HabilitaBotoes(true)

        this.$store.state.Controlopauta = this.listaPautasBloquadas[0].idControlopauta
        if (ls.get('role') === 'ROLE_PROF') {
          this.publicar_status = true
          this.btn_description = 'Mini Pauta Bloqueada'
        } else {
          this.publicar_status = true
          this.HabilitaBotoes(false)
          this.btn_description = 'Mini Pauta Bloqueada'
        }
      } else {
        this.publicar_status = false
        this.btn_description = 'Bloquear'
        this.HabilitaBotoes(false)
      }
    },

    async findDisciplinaInProfDisc (obj) {
      this.disciplinas = []
      this.$store.state.turma = obj.descricao
      this.$store.state.objturma = obj
      try {
        this.progresso_2 = true
        this.disciplinas = await axios

          .get('/findDisciplinaInProfDisc/' + obj.pkTurma)
          .then(res => res.data)
        this.progresso_2 = false
      } catch (error) {
        // this.isLoading = false
        this.progresso_2 = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    irAvaliarComportamento () {
      this.$store.state.rotas = 'lancar-trimestre-um'
      this.$store.state.Pautas = this.listEstudantfromPauta
      this.$router.push('comportamento')
    }
  }
}
</script>
